import React from 'react';
import {
  createRoutesFromElements,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { useEffect, useState } from 'react';

import { Button } from '@mui/material';
import { Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Pagination, CircularProgress } from '@mui/material';

import DataGrid from '../../../components/Datagrid/Datagrid';
import { columns as Columns } from './constants/table_columns_data';
import * as DEFAULT from './constants/list.default';
import service from './service';
import { useBoundStore } from '../../../stores/index';

const index = () => {
  const history = useNavigate();
  const location = useLocation();
  const columns = Columns();
  const textPool = useBoundStore((state) => state.textPool);
  const [filterData, setFilterData] = useState({ query: '' });
  const [sortModel, setSortModel] = useState(DEFAULT.SORT_MODEL);
  const [isLoading, setIsLoading] = useState(DEFAULT.IS_LOADING);
  const [page, setPage] = useState(DEFAULT.PAGE);
  const [reports, setReports] = useState(DEFAULT.REPORTS);
  const [count, setCount] = useState(DEFAULT.COUNT);
  const [isFetching, setIsFetching] = useState(false);
  const [token, setToken] = useState(null);

  const openDrawer = useBoundStore((state) => state.open);
  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);

  const getData = async () => {
    setIsLoading(true);
    const res = await service.getToken().then((res) => res);
    let token = res.data.data.token;

    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'time', sort: 'desc' };
    const payload = {
      param: {
        size: 10,
        page: page,
        sort: `${field},${sort}`,
        userId: JSON.parse(
          localStorage.getItem('permissions'),
        )?.data?.data?.roles.includes('KV_SUPERUSER')
          ? null
          : JSON.parse(localStorage.getItem('user'))?.user?.id,
        schemaId: 'WeeklyFleetSafetyReport',
      },
    };

    const result = await service.getReportingRequests(payload, token);
    const data = result?.data?.data || [];
    const properties = result?.data?.properties;
    setCount(properties?.totalPages);
    setReports(data);
    setIsLoading(false);
  };
  const paginationChange = (_, e_page) => setPage(e_page - 1);

  useEffect(() => {
    getData();
  }, [page, sortModel, location]);

  return (
    <div className="p-3 m-3 flex flex-col justify-center items-center">
      <div className="w-max max-[1315px]:w-full  p-3 m-3">
        {isLoading ? (
          <div className="flex justify-center items-center">
            <CircularProgress className="users-list-circular-progress" />
          </div>
        ) : (
          <>
            <div className="py-3 px-2 mx-3 my-2 flex flex-wrap justify-between max-sm:justify-center gap-3 items-center">
              <span className="text-lg sm:text-2xl max-sm:text-center">
                Yerlem Kavi <br className="sm:hidden" />
                {textPool['Filo Güvenlik Raporları']}
              </span>
              <Button
                startIcon={<Add />}
                sx={{ textTransform: 'none' }}
                variant="contained"
                color="primary"
                onClick={() => {
                  toggleRightDrawer();
                }}
                className="mx-3"
              >
                {textPool['Yeni Rapor İsteği']}
              </Button>
            </div>
            <div className="w-max max-[1315px]:w-full bg-white rounded-xl shadow-xl p-3 m-3">
              <DataGrid
                rows={reports}
                columns={columns}
                sortModel={sortModel}
                setSortModel={setSortModel}
              />

              <div className="flex justify-center items-center p-3 m-3">
                <Pagination
                  page={page + 1}
                  onChange={paginationChange}
                  count={count}
                  color="primary"
                  size="small"
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default index;
